import { CAI_MINT, mintMultipleNfts, buyMultipleNfts, sellMultipleNfts, cancelMultipleNfts, updatePriceMultipleNfts, } from '../../chains/svm/api';
export async function mintSvmNFTs(deps, uris, nfts) {
    const txId = await mintMultipleNfts(uris, CAI_MINT);
    deps.addTransaction(deps.activeChain, txId, 'Mint', nfts);
    return deps.txIdToLink(txId);
}
export async function buySvmNFTs(deps, nfts) {
    const txId = await buyMultipleNfts(nfts.map((info) => info.tokenId), CAI_MINT);
    deps.addTransaction(deps.activeChain, txId, 'Buy', nfts);
    return deps.txIdToLink(txId);
}
export async function listSvmNFTs(deps, nfts) {
    const txId = await sellMultipleNfts(nfts.map((info) => ({
        mint: info.tokenId,
        price: Number(info.price),
    })));
    deps.addTransaction(deps.activeChain, txId, 'List', nfts);
    return deps.txIdToLink(txId);
}
export async function delistSvmNFTs(deps, nfts) {
    const txId = await cancelMultipleNfts(nfts.map((nft) => nft.tokenId));
    deps.addTransaction(deps.activeChain, txId, 'Delist', nfts);
    return deps.txIdToLink(txId);
}
export async function updateSvmNFTPrices(deps, nfts) {
    const txId = await updatePriceMultipleNfts(nfts.map((info) => ({
        mint: info.tokenId,
        price: Number(info.price),
    })));
    deps.addTransaction(deps.activeChain, txId, 'Update Price', nfts);
    return deps.txIdToLink(txId);
}
